module.exports = __webpack_public_path__ + "static/steam-profile-visibility-guide-eaf5e65371712670a50971ad50ed3cdd.gif";